export { ProductDetailsLink } from './ProductDetailsLink.tsx';
